import templateUrl from './adp-files-dashboard.component.html';
import { EmploymentProcessingService } from '../../../../core/services';
import { UtilityService } from '../../../../core/services/utility.service';
import { IQService, ILogService } from 'angular';
import { getExceptionMessage } from '../../../../core/data-utils';
import { NewHireVM } from '../../../employment-processing/employment-processing-models';
import { NewHiresProcessor } from '../../../employment-processing/new-hires-processor.service';
import { TerminationsProcessor } from '../../../employment-processing/terminations-processor.service';
import { EmployeeChangeHistoryProcessor } from '../../../employment-processing/employee-change-history-processor.service';
import { DirectDepositProcessor } from '../../../employment-processing/direct-deposit-processor.service';

export const AdpFilesDashboardComponent = {
    templateUrl,
    controller: AdpFilesContainerController,
    controllerAs: "vm"
};

function AdpFilesContainerController($q: IQService, $log: ILogService, utilityService: UtilityService,
    employmentProcessingService: EmploymentProcessingService, newHiresProcessor: NewHiresProcessor,
    terminationsProcessor: TerminationsProcessor, employeeChangeHistoryProcessor: EmployeeChangeHistoryProcessor, directDepositProcessor: DirectDepositProcessor, payrollService, icdCorporationService, apexApiUrl: string) {
    'ngInject';

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.$onInit = onInit;
    vm.payWeekList;
    vm.corporationList;
    vm.corporation;
    vm.payWeek;
    vm.payWeek;

    vm.processedPayrollDate;
    vm.createAdpImportFile = createAdpImportFile;
    vm.createAdpCanadaImportFile = createAdpCanadaImportFile;
    vm.create401KExportAll = create401KExportAll;
    vm.createNewHiresReportAll = createNewHiresReportAll;
    vm.createTerminationsReportAll = createTerminationsReportAll;
    vm.createChangeHistoryReportAll = createChangeHistoryReportAll;
    vm.uploadAdpImportNumbers = uploadAdpImportNumbers;
    vm.uploadTerminations = uploadTerminations;
    vm.uploadChangeHistory = uploadChangeHistory;
    vm.uploadDirectDeposit = uploadDirectDeposit;
    vm.finishNewAdpNumbersImport = finishNewAdpNumbersImport;
    vm.finishTerminationsImport = finishTerminationsImport;
    vm.finishChangeHistoryImport = finishChangeHistoryImport;
    vm.finishDDImport = finishDDImport;
    vm.downloadAdpPayrollSummary = downloadAdpPayrollSummary;
    vm.downloadProcessedPayroll = downloadProcessedPayroll;
    vm.cancelTerminationsImport = cancelTerminationsImport;
    vm.cancelDDImport = cancelDDImport;
    vm.cancelChangeHistoryImport = cancelChangeHistoryImport;
    vm.cancelNewAdpNumbersImport = cancelNewAdpNumbersImport;
    vm.createDirectDepositReportAll = createDirectDepositReportAll;

    vm.handleChangeIcdCorporation = handleChangeIcdCorporation;
    vm.dropdownOptions = {
        //optionLabel: { Text: 'All Corporations', Value: 0 },
        dataSource: new kendo.data.DataSource({
            data: vm.corporationList,
        }),
        headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
        open: () => {
            setTimeout(() => {
                const widget = $("#corporation-list").data("kendoDropDownList");
                const source = vm.corporationList;
                $("#allcorps").off("click").on("click", (e) => {
                    const isChecked = $(e.target).prop("checked");

                    const filtered = isChecked
                        ? source.filter(c => c.IcdCorporationStatus === 'Active')
                        : source;
                    widget.dataSource.data(filtered);
                    widget.refresh();
                    widget.popup.open(); // keep it open after refresh
                });
            }, 0);
        }
    }

    function onInit() {
        vm.processedPayrollDate = new Date();
        vm.processedPayrollDate.setDate(vm.processedPayrollDate.getDate() - 30);
        loadPage(undefined);
    }

    function loadPage(icdCorporationID) {
        utilityService.showLoadingUntilResolved(
            getIcdCorporations()
                .then(function (icdCorporations) {
                    console.log(icdCorporations);
                    vm.corporationList = icdCorporations;
                    //vm.corporationList = icdCorporations;
                    vm.corporation = icdCorporations[0];
                    //let corporationID = vm.corporation.Value;
                    // eslint-disable-next-line eqeqeq
                    if (icdCorporationID != undefined) {
                        //corporationID = icdCorporationID;
                        vm.corporation = vm.corporationList.filter(function (corporation) {
                            // eslint-disable-next-line eqeqeq
                            return corporation.Value == icdCorporationID;
                        })[0];
                    }
                    return true;
                    //return retrievePayrollList(corporationID)
                    //return vm.corporation
                })
                //.then(function (payrollList) {
                //    //vm.payWeekList = payrollList.sort(function (a, b) {
                //    //    return a.StartDate < b.StartDate ? 1 : -1;
                //    //});
                //    //vm.payWeek = payrollList[0];
                //})
                .catch(function (ex) {
                    console.error(ex);
                    alert("initial load failed:" + utilityService.getExceptionMessage(ex));
                })
        );
    }

    //function retrievePayrollList(icdCorporationID) {
    //    return payrollService.retrieveIcdCorporationPayrolls(icdCorporationID)
    //        .then(function (payWeeks) {
    //            return payWeeks.map(function (payWeek) {
    //                return {
    //                    PayWeekID: payWeek.PayrollID,
    //                    Text: kendo.format("{0:MM/dd/yyyy} - {1:MM/dd/yyyy}", payWeek.StartDate, payWeek.EndDate),
    //                    StartDate: payWeek.StartDate,
    //                    EndDate: payWeek.EndDate,
    //                    IcdCorporationID: payWeek.IcdCorporationID,
    //                    PayrollID: payWeek.PayrollID
    //                };
    //            });
    //        })
    //}



    function getIcdCorporations() {
        return icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Roster", {})
            .then(function (icdCorporations) {
                var data = jQuery.map(icdCorporations, function (icdCorporation) {
                    return [{
                        Value: icdCorporation.Id,
                        Text: icdCorporation.Owner + ' - ' + icdCorporation.ClientName + (icdCorporation.ClientAs != null ? ' - ' + icdCorporation.ClientAs : ''),
                        IcdCorporationStatus: icdCorporation.IcdCorporationStatus
                    }];
                });
                data.sort(function (a, b) {
                    return a.Text.toLowerCase().localeCompare(b.Text.toLowerCase());
                });
                var mapped = [
                    { Value: 0, Text: "All Corporations", IcdCorporationStatus: "Active" },
                    ...data
                ]
                return mapped;
            });
    }

    function createAdpImportFile() {
        const urlStrPayroll = kendo.format(apexApiUrl + '/payrolls/{0}/adp-import-file.csv',
            vm.payWeek.PayrollID);
        try {
            window.location.href = urlStrPayroll;
        } catch (err) {
            alert("Creation of ADP Import File Failed:" + err.message);
        }
    }

    function create401KExportAll() {
        if (vm.corporation.Value === 0) {
            alert("Please choose a company to generate this report.");
            return;
        } else {
            const urlStrPayroll = kendo.format(apexApiUrl + '/employments/{0}/401k-export.csv',
                vm.corporation.Value);
            try {
                window.location.href = urlStrPayroll;
            } catch (err) {
                alert("Creation of 401K Export File Failed:" + err.message);
            }
        }
    }
    function createAdpCanadaImportFile() {
        const urlStrPayroll = kendo.format(apexApiUrl + '/payrolls/{0}/adp-canada-import-file.csv',
            vm.payWeek.PayrollID);
        window.location.href = urlStrPayroll;
    }

    function createNewHiresReportAll() {
        if (vm.corporation.Value) {
            window.location.href = apexApiUrl + "/employments/" + vm.corporation.Value + "/new-hires.xlsx";
        } else {
            window.location.href = apexApiUrl + "/employments/new-hires.xlsx";
        }
    }

    function createDirectDepositReportAll() {
        if (vm.corporation.Value) {
            window.location.href = apexApiUrl + "/employments/" + vm.corporation.Value + "/direct-deposit.xlsx";
        } else {
            window.location.href = apexApiUrl + "/employments/direct-deposit.xlsx";
        }
    }

    function createTerminationsReportAll() {
        if (vm.corporation.Value) {
            window.location.href = apexApiUrl + "/employments/" + vm.corporation.Value + "/terminations.xlsx";
        } else {
            window.location.href = apexApiUrl + "/employments/terminations.xlsx";
        }
    }
    function createChangeHistoryReportAll() {
        //window.location.href = apexApiUrl + "/employments/changehistory.xlsx";
        if (vm.corporation.Value) {
            window.location.href = apexApiUrl + "/employments/" + vm.corporation.Value + "/changehistory.xlsx";
        } else {
            window.location.href = apexApiUrl + "/employments/changehistory.xlsx";
        }
    }
    function downloadAdpPayrollSummary() {
        const urlStrPayroll = kendo.format(apexApiUrl + "/payrolls/adp-payroll-summary?icdCorporationID={0}&startDate={1:yyyy-MM-dd}&endDate={2:yyyy-MM-dd}",
            vm.corporation.Value, vm.payWeek.StartDate, vm.payWeek.EndDate);
        window.location.href = urlStrPayroll;
    }

    function downloadProcessedPayroll() {
        const urlStrPayroll = kendo.format(apexApiUrl + "payrolls/processed-payrolls?completedDate={0:yyyy-MM-dd}",
            vm.processedPayrollDate);
        window.location.href = urlStrPayroll;
    }

    function uploadAdpImportNumbers() {

        if (!vm.importADPNumbersFiles) return;

        const file = vm.importADPNumbersFiles;
        if (file) {
            vm.importADPNumbersFile = file;
            vm.newADPEmpNumbers = null;
            utilityService.showLoading();
            employmentProcessingService.parseNewHiresDataFromFile(file)
                .then(function (newHires: NewHireVM[]) {
                    for (let i = 0; i < newHires.length; i++) {
                        newHires[i].isSelected = (newHires[i].ADPEmployeeID || "") !== "";
                    }
                    vm.newADPEmpNumbers = newHires;
                })
                .catch(function (ex) {
                    vm.importADPNumbersFile = null;
                    alert("Reading the file failed. Please make sure it is in the correct format.");
                })
                .then(function () {
                    utilityService.hideLoading();
                });
        }
    }

    function finishNewAdpNumbersImport() {
        const hires = vm.newADPEmpNumbers.filter(e => e.isSelected);
        // Minimize the number of simulataneous requests by capping off a chunk of batch updates.
        const maxChunkSize = 20;
        const result = {
            succeeded: 0,
            failed: 0,
            totalCount: hires.length,
            messages: [],
            promises: []
        };
        let chunkPromise = $q.resolve();
        for (let i = 0; i < hires.length; i += maxChunkSize) {
            const chunkHires = hires.slice(i, i + maxChunkSize);
            chunkPromise = chunkPromise.then(() => newHiresProcessor.batchProcessNewHires(chunkHires))
                .then(chunkResult => {
                    result.succeeded += chunkResult.succeeded;
                    result.failed += chunkResult.failed;
                    result.messages.push(...chunkResult.messages);
                });
        }

        const allSaved = chunkPromise.then(() => {
            if (result.failed) {
                const count = result.totalCount;
                alert(`There was an error processing the new hires. ${result.succeeded}/${count}
                    succeeded, ${result.failed}/${count} failed`);
                $log.warn("New hires processing failed.", result.messages);
                return;
            }
            alert("All selected new hires were processed successfully");
        })
            .catch(ex => {
                // Note, this isn't the usual case where a single update failed.
                $log.error(ex);
                alert("Saving failed: " + getExceptionMessage(ex))
            });

        utilityService.showLoadingUntilResolved(allSaved);
    }

    function finishChangeHistoryImport() {
        const changeHistory = vm.changehistoryEmployees.filter(employee => employee.isSelected);
        // Minimize the number of simulataneous requests by capping off a chunk of batch updates.
        if (!changeHistory.length) return;
        // Single batch call — no more chunking needed
        const allSaved = employeeChangeHistoryProcessor
            .batchProcessChangeHistory(changeHistory)
            .then(result => {
                if (result.failed) {
                    alert(`There was an error processing the employee change history. ` +
                        `${result.succeeded}/${changeHistory.length} succeeded, ` +
                        `${result.failed}/${changeHistory.length} failed`);
                    $log.warn("Employee change history processing failed.", result.messages);
                    return;
                }
                alert("All selected change history were processed successfully");
            })
            .catch(ex => {
                $log.error(ex);
                alert("Saving failed: " + getExceptionMessage(ex));
            });

        utilityService.showLoadingUntilResolved(allSaved);
    }

    function finishDDImport() {
        const dds = vm.ddEmployees.filter(function (dd) {
            return dd.IsSelected;
        });
        // Minimize the number of simulataneous requests by capping off a chunk of batch updates.
        const maxChunkSize = 20;
        const result = {
            succeeded: 0,
            failed: 0,
            totalCount: dds.length,
            messages: [],
            promises: []
        };
        let chunkPromise = $q.resolve();
        for (let i = 0; i < dds.length; i += maxChunkSize) {
            const chunkdd = dds.slice(i, i + maxChunkSize);
            chunkPromise = chunkPromise
                .then(() => directDepositProcessor.batchProcessDirectDeposit(chunkdd))
                .then(chunkResult => {
                    result.succeeded += chunkResult.succeeded;
                    result.failed += chunkResult.failed;
                    result.messages.push(...chunkResult.messages);
                });
        }

        const allSaved = chunkPromise.then(() => {
            if (result.failed) {
                const count = result.totalCount;
                alert(`There was an error processing the employee change history. ${result.succeeded}/${count}
                    succeeded, ${result.failed}/${count} failed`);
                $log.warn("Employee change history processing failed.", result.messages);
                return;
            }
            alert("All selected change history were processed successfully");
        })
            .catch(ex => {
                // Note, this isn't the usual case where a single update failed.
                $log.error(ex);
                alert("Saving failed: " + getExceptionMessage(ex))
            });
        utilityService.showLoadingUntilResolved(allSaved);
    }

    function finishTerminationsImport() {
        //TODO: Refactor this entire piece of logic (parsing and processing) into a shared component.
        const terminations = vm.terminatedEmployees.filter(function (employee) {
            return employee.isSelected;
        });
        // Minimize the number of simulataneous requests by capping off a chunk of batch updates.
        const maxChunkSize = 20;
        const result = {
            succeeded: 0,
            failed: 0,
            totalCount: terminations.length,
            messages: [],
            promises: []
        };
        let chunkPromise = $q.resolve();
        for (let i = 0; i < terminations.length; i += maxChunkSize) {
            const chunkTerminations = terminations.slice(i, i + maxChunkSize);
            chunkPromise = chunkPromise
                .then(() => terminationsProcessor.batchProcessTermination(chunkTerminations))
                .then(chunkResult => {
                    result.succeeded += chunkResult.succeeded;
                    result.failed += chunkResult.failed;
                    result.messages.push(...chunkResult.messages);
                });
        }

        const allSaved = chunkPromise.then(() => {
            if (result.failed) {
                const count = result.totalCount;
                alert(`There was an error processing the terminations. ${result.succeeded}/${count}
                    succeeded, ${result.failed}/${count} failed`);
                $log.warn("Terminations processing failed.", result.messages);
                return;
            }
            alert("All selected terminations were processed successfully");
        })
            .catch(ex => {
                // Note, this isn't the usual case where a single update failed.
                $log.error(ex);
                alert("Saving failed: " + getExceptionMessage(ex))
            });
        utilityService.showLoadingUntilResolved(allSaved);
    }

    function cancelNewAdpNumbersImport() {
        vm.importADPNumbersFiles = null;
        vm.importADPNumbersFile = null;
        vm.newADPEmpNumbers = null;
    }

    function cancelTerminationsImport() {
        vm.terminationsFiles = null;
        vm.terminationsFile = null;
        vm.terminatedEmployees = null;
    }

    function cancelDDImport() {
        vm.ddFiles = null;
        vm.ddFile = null;
        vm.ddEmployees = null;
    }

    function cancelChangeHistoryImport() {
        vm.changehistoryFiles = null;
        vm.changehistoryFile = null;
        vm.changehistoryEmployees = null;
    }

    function uploadChangeHistory() {
        if (!vm.changehistoryFiles) return;
        const file = vm.changehistoryFiles;
        if (file) {
            vm.changehistoryFile = file;
            vm.changehistoryEmployees = null;
            utilityService.showLoading();
            employmentProcessingService.parseEmployeeChangeRequestDataFromFile(file)
                .then(function (changeHistory) {
                    for (let i = 0; i < changeHistory.length; i++) {
                        changeHistory[i].isSelected = changeHistory[i].Active;
                    }
                    vm.changehistoryEmployees = changeHistory;
                })
                .catch(function (ex) {
                    vm.changehistoryFile = null;
                    alert("Reading the file failed. Please make sure it is in the correct format.");
                })
                .then(function () {
                    utilityService.hideLoading();
                });
        }
    }

    function uploadTerminations() {
        if (!vm.terminationsFiles) return;

        const file = vm.terminationsFiles;
        if (file) {
            vm.terminationsFile = file;
            vm.terminatedEmployees = null;
            utilityService.showLoading();
            employmentProcessingService.parseTerminationsDataFromFile(file)
                .then(function (terminations) {
                    //vm.terminatedEmployees = terminations.filter(x => x.Selected === true);
                    for (let i = 0; i < terminations.length; i++) {
                        terminations[i].isSelected = terminations[i].Selected;
                    }
                    vm.terminatedEmployees = terminations;
                })
                .catch(function (ex) {
                    vm.terminationsFile = null;
                    alert("Reading the file failed. Please make sure it is in the correct format.");
                })
                .then(function () {
                    utilityService.hideLoading();
                });
        }
    }

    function uploadDirectDeposit() {
        if (!vm.ddFiles) return;
        const file = vm.ddFiles;
        if (file) {
            vm.ddFile = file;
            vm.ddEmployees = null;
            utilityService.showLoading();
            employmentProcessingService.parseDirectDepositDataFromFile(file)
                .then(function (directdeposits) {
                    //for (let i = 0; i < directdeposits.length; i++) {
                    //    directdeposits[i].isSelected = directdeposits[i].IsSelected;
                    //}
                    vm.ddEmployees = directdeposits;
                })
                .catch(function (ex) {
                    vm.ddFile = null;
                    alert("Reading the file failed. Please make sure it is in the correct format.");
                })
                .then(function () {
                    utilityService.hideLoading();
                });
        }
    }

    function handleChangeIcdCorporation() {
        loadPage(vm.corporation.Value);
    }
}
